/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCloudExadataInfrastructure = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M15 4a4.974 4.974 0 0 0-4.643 3.194A4.84 4.84 0 0 0 9 7a5 5 0 0 0-5 5v.491c-1.465 1.157-2.207 2.717-2.583 3.972a10.325 10.325 0 0 0-.41 2.31 5.91 5.91 0 0 0-.007.204v.022L2 19H1v1h6v-2H3.107c.049-.285.121-.613.226-.963.337-1.124.986-2.381 2.222-3.205L6 13.535V12a3 3 0 0 1 3-3c.55 0 1.068.16 1.528.436l1.343.804.165-1.556A2.988 2.988 0 0 1 15 6a3 3 0 0 1 3 3c0 .005 0 .023-.007.076l-.007.05-.006.044-.015.133-.071.729.673.288a4 4 0 0 1-.766 7.6l.398 1.96a6.002 6.002 0 0 0 1.797-11.078A5 5 0 0 0 15 4zm-5 8H9v11h7V12h-1zm1 9v-7h3v7zm2-6h-1v1h1zm0 2h-1v1h1z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCloudExadataInfrastructure as CloudExadataInfrastructure };
